import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from "@angular/core";

@Pipe({
  name: 'showEditButton'
})
@Injectable({ providedIn: 'root' })
export class ShowEditButtonPipe implements PipeTransform {

  //This method helps in identifying the whether the edit icon should be shown or not
  //This method checks if the rule is used in the final expression if not used then it will return true which means the edit icon is not shown if used it will return false which means the edit icon is shown
  transform(ruleName: string, finalRuleExpression): boolean {
    let ruleNamesUsedInFinalExp =
      this.getTheRuleNames(finalRuleExpression);
    return !ruleNamesUsedInFinalExp.includes(ruleName);
  }

  getTheRuleNames(finalRuleExpression: string) {
    let ruleNamesToReturn = [];
    const regexSingleRule =
      /^\(\s*[a-zA-Z0-9_]+(?:\s+(?!AND|OR\b)[a-zA-Z0-9_]+)*\s*\)$/i;
    const regexAndOrRule =
      /^\(\s*[a-zA-Z0-9_ ]+(\s+(AND|OR)\s+[a-zA-Z0-9_ ]+)+\s*\)$/i;
    const regexMultipleAndOr =
      /^\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)(\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\))*$/i;
    if (regexSingleRule.test(finalRuleExpression.trim())) {
      const ruleName = finalRuleExpression.replace(/[()]/g, "").trim();
      ruleNamesToReturn.push(ruleName);
    } else if (regexAndOrRule.test(finalRuleExpression.trim())) {
      const innerExpression = finalRuleExpression.trim().slice(1, -1);
      const ruleNames = innerExpression.split(/\s+(AND|OR)\s+/i);
      ruleNamesToReturn.push(...ruleNames);
    } else if (regexMultipleAndOr.test(finalRuleExpression.trim())) {
      const regexGroup =
        /\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)/gi;
      const groups = finalRuleExpression.match(regexGroup) || [];
      groups.map((group: any) => {
        const innerExpression = group.trim().slice(1, -1);
        const ruleNames = innerExpression.split(/\s+(AND|OR)\s+/i);
        ruleNamesToReturn.push(...ruleNames);
      });
    }
    return ruleNamesToReturn;
  }
}
